import React from 'react';
import OrderInfoCard from './OrderInfoCard';
import '../css/cardContainer.css';
import OtherCard from './OtherCard';
import GenericCard from './GenericCard';
import { getOrderTotalsData } from '../utils/utils';
import { t } from 'i18next';




const CardContainer = ({ orderData}) => {
    const otherCountries = process.env.REACT_APP_Other_Countries.split("|");


    const orderInfo = orderData?.orderInfo;
    const salesorg = orderData?.orderInfo?.salesorg;
    const partnerInfo = orderData?.partnerInfo;

    const orderTotals = orderData?.orderTotal;

    const orderTotalsData = getOrderTotalsData(orderTotals);



    return (
        <div className='card-cnt'>
            <div className="row">

                <OrderInfoCard
                    orderInfo={orderInfo}
                    color='#6f42c1'
                    t={t}
                />

                <OtherCard
                    type={t('shippingInfo')}
                    name={partnerInfo && partnerInfo.soldToParty}
                    street={partnerInfo && partnerInfo.street}
                    city={partnerInfo && partnerInfo.city}
                    pin={partnerInfo && partnerInfo.billToPartyPostalCode}
                    country={partnerInfo && partnerInfo.billToPartyCountry}
                    color='#6f42c1'
                />

                {/* <GenericCard dataObj={orderTotalsData} /> */}

                {
                    salesorg && otherCountries.includes(salesorg) &&
                    (partnerInfo && (partnerInfo.endUserName || partnerInfo.endUserStreet || partnerInfo.endUserCity || partnerInfo.endUserPostal || partnerInfo.endUserCountry)) &&
                    <OtherCard
                        type={t('endCustomer')}
                        name={partnerInfo && partnerInfo.endUserName}
                        street={partnerInfo && partnerInfo.endUserStreet}
                        city={partnerInfo && partnerInfo.endUserCity}
                        pin={partnerInfo && partnerInfo.endUserPostal}
                        country={partnerInfo && partnerInfo.endUserCountry}
                        color='#6f42c1'
                    />
                }

            </div>
        </div>
    )
}

export default CardContainer